import { Box, styled } from '@mui/material';

const RoundedTransparentBox = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.8)', // 設置背景顏色爲白色並設置透明度爲0.5
  borderRadius: theme.shape.borderRadius, // 設置圓角邊框半徑爲主題中定義的值
  padding: '2px',
}));
export default RoundedTransparentBox;
